import React, { useEffect, useRef, useState } from "react";
import * as ST from "./styled";
import {
	useGetMaterialFilterListQuery,
	useGetMaterialListQuery,
} from "src/business.InterfaceLayer/store/entities/materialEvents.entity/materialEventsAPI";

import {
	Box,
	debounce,
	LinearProgress,
	Popover,
	Typography,
} from "@mui/material";
import { ReactComponent as UpDownIcon } from "src/general/constants/icons/UpDown.svg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ReactComponent as LockIcon } from "src/general/constants/icons/lock.svg";
import Colors from "src/general/constants/colors";
import { formatDateToUTC } from "src/business.InterfaceLayer/store/services/formatDateToUTC";
import {
	Link,
	useNavigate,
	useParams,
	useSearchParams,
} from "react-router-dom";

const MaterialsUser = (): JSX.Element => {
	const navigate = useNavigate();

	// фильтр логика отслеживания количества элементов

	const [isExpanded, setIsExpanded] = useState(false);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const [visibleItems, setVisibleItems] = useState<any[]>([]);
	const [hiddenItems, setHiddenItems] = useState<any[]>([]);
	const materialLinksRef = useRef<HTMLDivElement>(null);

	const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
	const ALL_MATERIALS = "Все материалы";

	// получение всех материалов
	const {
		data: dataGetMaterialList,
		error: errorGetMaterialList,
		isLoading: isLoadingGetMaterialList,
	} = useGetMaterialListQuery();
	// фильтрация списка материалов
	const {
		data: dataGetMaterialFilterList,
		error: errorGetMaterialFilterList,
		isLoading: isLoadingGetMaterialFilterList,
	} = useGetMaterialFilterListQuery();

	//////////// Определение видимости элементов если те не помещаются в контейнер по ширине
	const updateVisibleItems = () => {
		if (!materialLinksRef.current) return;

		const containerWidth = materialLinksRef.current.clientWidth - 400; // ширина контейнера - ширина Ещё
		const itemWidth = 140; // ширина одного элемента
		const visibleCount = Math.floor(containerWidth / itemWidth) - 1; // количество видимых элементов

		const badges = dataGetMaterialFilterList?.programs || [];
		const newVisibleItems = badges.slice(0, visibleCount);
		const newHiddenItems = badges.slice(visibleCount);

		setVisibleItems(newVisibleItems);
		setHiddenItems(newHiddenItems);
	};

	useEffect(() => {
		updateVisibleItems();
		window.addEventListener("resize", updateVisibleItems);
		return () => {
			window.removeEventListener("resize", updateVisibleItems);
		};
	}, [dataGetMaterialFilterList]);

	const toggleExpandTicTac = (event: React.MouseEvent<HTMLDivElement>) => {
		setAnchorEl(event.currentTarget); // элемент, к которому привяжется Popover
		setIsExpanded(!isExpanded);
	};
	const toggleExpandTicTacClose = () => {
		setAnchorEl(null);
		setIsExpanded(false);
	};

	//фильтрация
	const toggleFilter = (filter: string) => {
		if (filter === ALL_MATERIALS) {
			setSelectedFilters([]);
		} else {
			setSelectedFilters((prev) => (prev.includes(filter) ? [] : [filter]));
		}
	};
	const filteredModules = dataGetMaterialList?.data.filter((module) => {
		if (selectedFilters.length === 0) return true;
		return selectedFilters.some((filter) => module.program.includes(filter));
	});

	//просрочка модуля
	const isEndTime = (accessDate: string) => {
		const expiryDate = new Date(accessDate);
		const currentDate = new Date();

		return currentDate > expiryDate;
	};

	// console.log("dataGetMaterialList", dataGetMaterialList?.data);
	// console.log("dataGetMaterialFilterList", dataGetMaterialFilterList?.programs);
	return (
		<ST.MaterialEventContainer id="MaterialEvent">
			<ST.MaterialLinks
				id="MaterialLinks_Tile"
				ref={materialLinksRef}
			>
				<ST.TicTac
					key="all-materials"
					onClick={() => toggleFilter(ALL_MATERIALS)}
					sx={{
						backgroundColor:
							selectedFilters.length === 0
								? Colors.GREEN_LIGHT
								: Colors.GREY_F6,
					}}
				>
					<Typography variant="caption">{ALL_MATERIALS}</Typography>
				</ST.TicTac>
				{visibleItems.map((badge, index) => (
					<ST.TicTac
						key={index}
						onClick={() => toggleFilter(badge.name)}
						sx={{
							backgroundColor: selectedFilters.includes(badge.name)
								? Colors.GREEN_LIGHT
								: Colors.GREY_F6,
						}}
					>
						<Typography variant="caption">{badge.name}</Typography>
					</ST.TicTac>
				))}

				{hiddenItems.length > 0 && (
					<ST.MoreTicTac onClick={toggleExpandTicTac}>
						<Typography variant="caption">Ещё</Typography>
						<ST.ButtonUpDown>
							<UpDownIcon
								style={{
									transform: !isExpanded ? "rotate(180deg)" : "rotate(0deg)",
									transition: "transform 0.3s ease",
								}}
							/>
						</ST.ButtonUpDown>
					</ST.MoreTicTac>
				)}

				<Popover
					open={open}
					anchorEl={anchorEl}
					onClose={toggleExpandTicTacClose}
					anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
					transformOrigin={{ vertical: "top", horizontal: "right" }}
					PaperProps={{
						sx: { borderRadius: "16px" },
					}}
				>
					<ST.StyledBox id="tictac allMenu">
						{hiddenItems.map((badge, index) => (
							<ST.TicTac
								key={index}
								onClick={() => toggleFilter(badge.name)}
								sx={{
									backgroundColor: selectedFilters.includes(badge.name)
										? Colors.GREEN_LIGHT
										: Colors.GREY_F6,
								}}
							>
								<Typography variant="caption">{badge.name}</Typography>
							</ST.TicTac>
						))}
					</ST.StyledBox>
				</Popover>
			</ST.MaterialLinks>

			<ST.VideoAndInfoContainer>
				{filteredModules?.map((module) => (
					<ST.VideoModule
						key={module.id}
						id="VideoModule"
					>
						<ST.TitleContainer>
							<ST.InfoTitle>
								{isEndTime(module.accessDate) && <LockIcon />}
								<Typography
									variant="body1"
									sx={{ color: Colors.BLUE_015 }}
								>
									{module.name}
								</Typography>
							</ST.InfoTitle>

							<ST.Baydges id="znachki">
								<ST.Baydge sx={{ backgroundColor: module.programColor }}>
									<Typography variant="body1">{module.program}</Typography>
								</ST.Baydge>
							</ST.Baydges>
						</ST.TitleContainer>

						<ST.NameModule id={"NameModule"}>
							<Typography variant="body1">{module.description}</Typography>
						</ST.NameModule>

						<ST.ProgressBar id="ProgressBar">
							<ST.TitleProgressBarContainer>
								<ST.TitleRowContainer>
									<Typography variant="body2">Пройдено уроков</Typography>
									<Typography
										variant="subtitle2"
										sx={{ color: Colors.GREEN }}
									>
										&nbsp;
										{module.progress.done} из {module.progress.total}
									</Typography>
								</ST.TitleRowContainer>
							</ST.TitleProgressBarContainer>
							<Box sx={{ width: "100%", mt: 1, position: "relative" }}>
								<LinearProgress
									variant="determinate"
									value={module.progress.percent}
									sx={{
										height: "20px",
										borderRadius: "4px",
										position: "relative",
									}}
								/>
								<Typography
									variant="subtitle2"
									sx={{
										color: Colors.WHITE,
										position: "absolute",
										top: "50%",
										left:
											module.progress.percent === 0
												? `24px`
												: `${module.progress.percent}%`,
										transform: "translate(-100%, -50%)",
										paddingRight: module.progress.percent === 0 ? "0px" : "8px",
									}}
								>
									&nbsp;{module.progress.percent}%
								</Typography>
							</Box>
						</ST.ProgressBar>

						<ST.LeftRightButtons>
							{module.test?.link && (
								<ST.LinkButton
									onClick={() => navigate(module.test.link)}
									sx={{
										width: !isEndTime(module.accessDate) ? "100%" : "50%",
										"@media screen and (max-width:550px)": {
											width: !isEndTime(module.accessDate) ? "100%" : "80%",
										},
									}}
								>
									<Typography
										variant="body1"
										sx={{
											color: Colors.BLUE_015,
										}}
									>
										Перейти к тесту
									</Typography>
									<ArrowForwardIcon
										sx={{
											color: Colors.BLUE_015,
											transform: "scaleX(1.2)",
										}}
									/>
								</ST.LinkButton>
							)}

							{!isEndTime(module.accessDate) && (
								<ST.LinkButton
									onClick={() => navigate(`/lk/materials/${module.id}`)}
									// если нет кнопки теста
									sx={{
										width: module.test === null ? "50%" : "100%",
										"@media screen and (max-width:550px)": {
											width: module.test === null ? "80%" : "100%",
										},
									}}
								>
									<Typography
										variant="body1"
										sx={{
											color: Colors.BLUE_015,
										}}
									>
										Перейти к материалам
									</Typography>
									<ArrowForwardIcon
										sx={{
											color: Colors.BLUE_015,
											transform: "scaleX(1.2)",
										}}
									/>
								</ST.LinkButton>
							)}
						</ST.LeftRightButtons>

						<ST.TitleRowContainer>
							<Typography
								variant="subtitle1"
								sx={{ display: "flex" }}
							>
								Срок доступа:{" "}
							</Typography>
							<ST.StyledTypography variant="body1">
								{isEndTime(module.accessDate) ? (
									<Typography sx={{ color: Colors.RED }}>Истёк</Typography>
								) : (
									formatDateToUTC(module.accessDate)
								)}
							</ST.StyledTypography>
						</ST.TitleRowContainer>
					</ST.VideoModule>
				))}
			</ST.VideoAndInfoContainer>
		</ST.MaterialEventContainer>
	);
};

export default MaterialsUser;
